<template>
  <div>
    <div class="container">
      <!-- handleEvent blur | handleSuggestions带提示搜索框 -->
      <e-search
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleSuggestions="handleSuggestions"
        @handleFilter="handleSearch"
        @handleFocus="handleFocus"
        @handleInput="handleInput"
        @handleReset="handleReset"
        @handleEvent="handleEvent"
        @handleSelect="handleSelect"
      ></e-search>
    </div>

    <div class="container flex-box">
      <div class="color">提示：</div>
      <div class="box-content">
        请提交申请前检查企业运营中心>企业管理>设置下的
        <span class="link" @click="goUrl('/supplyServiceCapabilityInfo')">供应服务能力信息、</span>
        <span class="link" @click="goUrl('/qualificationInformation')">资质信息、</span>
        <span class="link" @click="goUrl('/manageInfo')">管理信息</span>
        中的信息是否维护，如果未维护，您提交的申请将不予通过。
        您申请的目录仅能用于向中国石化以外的外部客户销售商品，不适用于中国石化保供业务，不能向中国石化用户销售商品，尽请知悉。
      </div>
    </div>

    <!-- 选择企业类型-上传附件 -->
    <div class="company-info container">
      <div class="company-title">企业信息</div>
      <!-- 选择企业类型 -->
      <div class="company-select">
        <div>
          企业类型：
          <el-radio-group v-model="formData.companyType">
            <el-radio v-for="item in companyTypeList" :key="item.id" :label="item.id">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="companyType-text">{{ companyTypeText() }}</div>
      <el-upload
        v-show="formData.companyType != 'DISTRIBUTOR'"
        class="company-upload"
        :action="uploadUrl"
        :headers="headers"
        :before-upload="handleBeforeUpload"
        :before-remove="handleBeforeRemove"
        :on-remove="handleImgRemove"
        :on-preview="handlePreview"
        :on-success="handleImgSuccess"
        :file-list="fileList"
        accept=".pdf, .jpg, .jpeg, .png"
        :limit="10"
      >
        <el-button
          v-show="uploadFlag"
          :disabled="fileList.length >= 10 || isLoad"
          size="small"
          class="upload-btn"
          type="primary"
        >
          上传附件
        </el-button>
        <div class="msg" @click.stop>最多上传 10个文件，大小不能超过 10M</div>
      </el-upload>
    </div>

    <div class="container" style="padding: 20px">
      <div class="cascader-content">
        <div>选择产品类目：</div>
        <el-cascader
          ref="cascader"
          :key="propsKey"
          v-model="valueModel"
          placeholder="试试搜索"
          :options="treeData"
          :props="props"
          :filter-method="dataFilter"
          filterable
          collapse-tags
          @change="caChange"
        ></el-cascader>
      </div>

      <!-- 列表 -->
      <!-- :style="{
          'margin-top': formData.companyType == 'DISTRIBUTOR' ? '0px' : '70px'
        }" -->
      <TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" max-height="455">
        <template #index="slot">{{ slot.scope.$index + 1 }}</template>
        <template #operation="del">
          <el-link
            icon="el-icon-delete"
            type="danger"
            :underline="false"
            @click="handleClickDel(del.scope.row, del.scope.$index)"
          >
            删除
          </el-link>
        </template>
      </TableList>
    </div>

    <!-- 提示  -->
    <div v-if="abbreviation" class="exclusive-top container" style="margin-bottom: 20px">
      <!-- <div v-if="submitBtnType == 'info'">
          <span>{{ message }}</span>
        </div> -->
      <div v-if="abbreviation">
        <span class="color">提示：</span>
        您的服务管家为：{{ abbreviation }}。审核联系人
        <span v-for="(item, index) in butlerInfo" :key="index">
          <span>{{ item.nickName }}：{{ item.mobile }}</span>
        </span>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="handle-bottom-btn">
      <el-button type="primary" :loading="loadingSub" @click="clickSubmitApply">提交申请</el-button>
    </div>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import { debounce } from '@/modules/projectA/utils/throttle.js';
import categoryDialog from '@/modules/projectA/components/category/categoryDialog copy.vue';
import TableList from '@/modules/projectA/components/common/e-table-list';
import { epecToken } from '@/modules/projectA/utils/globalData';
import api from '@/modules/projectA/api/company/index';
import Api from '@/modules/projectA/api/organization/index';
import apiLogin from '@/modules/projectA/api/login/index';
import _ from 'lodash';

export default {
  name: '',
  components: {
    eSearch,
    // addUnit,
    categoryDialog,
    TableList,
  },
  props: {},
  data() {
    return {
      valueModel: [],
      // 解决 v-model值改变后 选择没改变的问题  只要model改变 propsKey就改变
      propsKey: 1000,
      pagesize: 10, //    每页的数据
      currentPage: 1, // 初始页
      props: {
        children: 'children',
        label: 'categoryName',
        value: 'categoryId',
        multiple: true,
        expandTrigger: 'hover',
        // disabled: 'applyFlag'
      },
      treeData: [],
      tableData: [],
      cloneTableData: [],
      // 2023-09-06 迭代结束
      dialogVisible: true,
      message: '',
      submitBtnType: 'primary', // primary 风险等级B级一下 按钮置灰 info
      formData: {
        companyType: '',
      },
      companyTypeList: [
        { name: '生产商', id: 'PRODUCER' },
        { name: '代理商', id: 'AGENT' },
        { name: '流通商', id: 'DISTRIBUTOR' },
      ],
      uploadUrl: api.companyFileUpload,
      headers: epecToken,
      fileList: [],
      uploadFlag: true,
      queryData: {
        firstCategoryName: '',
        secondCategoryName: '',
        thirdCategoryName: '',
        fourthCategoryName: '',
        pageNum: 1,
        pageSize: 10,
      },
      firstCategoryNameList: [],
      secondCategoryNameList: [],
      thirdCategoryNameList: [],
      fourthCategoryNameList: [],

      fieldList: [
        {
          label: '一级类目名称',
          type: 'autocomplete',
          value: 'firstCategoryName',
        },
        {
          label: '二级类目名称',
          type: 'autocomplete',
          value: 'secondCategoryName',
        },
        {
          label: '三级类目名称',
          type: 'autocomplete',
          value: 'thirdCategoryName',
        },
        {
          label: '四级类目名称',
          type: 'autocomplete',
          value: 'fourthCategoryName',
        },
      ],
      tableData2: [],
      queryArr: [],
      tableLabel: [
        {
          label: '一级类目名称',
          param: 'firstCategoryName',
          align: 'center',
        },
        { label: '二级类目名称', param: 'secondCategoryName', align: 'center' },
        { label: '三级类目名称', param: 'thirdCategoryName', align: 'center' },
        { label: '四级类目名称', param: 'fourthCategoryName', align: 'center' },
        {
          label: '操作',
          width: '300',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      loading: false,
      listTypeInfo: {},
      categoryVisible: false,
      tableArr: [],
      category: {},
      levelArr: [],
      labelName: '',
      titleName: '',
      tableFlag: false,
      seekFlag: false,
      levelList1: [],
      levelList2: [],
      levelList3: [],
      levelList4: [],
      loadingSub: false,
      butlerInfo: [],
      abbreviation: '',
      riskScore: 0,
      getLoginFront: null,
      getLoginRear: null,
      allCategoryList: [],
      isOnlyPDF: true,
      isLoad: false,
    };
  },
  mounted() {
    // 开启延长登录
    this.getLoginActive();
    this.getCategoryTree();
  },
  async created() {
    this.$setStore('tableData_list', this.tableData);
    this.queryCompanyButler();
    this.checkCompanyRisk();
    this.checkCompanyRiskPoint();
    // 查询公司身份及附件
    this.queryCompanyIdentityAttach();
  },
  beforeDestroy() {
    this.tableData = [];
    this.$setStore('tableData_list', this.tableData);
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },
    // 迭代 2023-09-06 开始
    // 前端假分页
    fakeHandleSizeChange(size) {
      this.pagesize = size;
      console.log(this.pagesize); // 每页下拉显示数据
    },
    // 切换当前页码时
    fakeHandleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); // 点击第几页
    },
    dealTree(data, id) {
      let arr = [];
      for (let v = 0; v < data.length; v++) {
        if (data[v].type === id) {
          data[v].children = null;
        } else if (data[v].children) {
          this.dealTree(data[v].children, '631');
        }
      }
      arr = data;
      return arr;
    },
    dataFilter(node, val) {
      if (node.label.indexOf(val) !== -1 && !node.hasChildren) {
        return true;
      }
    },
    disabledFn(data, node) {
      if (!data.applyFlag) {
        return true;
      }
      return false;
    },
    setTreeRecursion(data) {
      data.map((item, index) => {
        item.disabled = !!item.applyFlag;
        if (item.children && item.children.length != 0) {
          this.setTreeRecursion(item.children);
        }
      });
      return data || [];
    },
    async getCategoryTree() {
      const result = await Api.queryApplyCategoryTree();
      if (result.code === '200') {
        this.treeData = this.setTreeRecursion(result?.data);
      }
    },
    caChange(val) {
      const data = this.$refs.cascader.getCheckedNodes();
      console.log(data, 'caChange');
      const lastLevelData = data.filter((el) => !el.hasChildren);
      console.log(lastLevelData, 'lastLevelData');
      /*
        data: 源数据,
        pathNodes: 所有父级对象
      */
      let tableData = [];
      const valueModel = [];
      lastLevelData.forEach((el) => {
        const obj = {};
        const arr = [];
        obj.categoryId = el.value;
        obj.categoryName = el.label;
        obj.mdmCode = el.data.mdmCategoryCode;
        obj.mdmName = el.data.mdmCategoryName;
        // pathNodes
        /*
          firstCategoryName
          firstCategoryId
          secondCategoryName
          secondCategoryId
          thirdCategoryName
          thirdCategoryId
          fourthCategoryName
          fourthCategoryId
        */
        const [first, second, third, fourth] = el.pathNodes;
        obj.firstCategoryName = first.data.categoryName;
        obj.firstCategoryId = first.data.categoryId;
        arr.push(obj.firstCategoryId);
        obj.secondCategoryName = second.data.categoryName;
        obj.secondCategoryId = second.data.categoryId;
        arr.push(obj.secondCategoryId);
        obj.thirdCategoryName = third.data.categoryName;
        obj.thirdCategoryId = third.data.categoryId;
        arr.push(obj.thirdCategoryId);
        obj.fourthCategoryName = fourth?.data.categoryName || '';
        obj.fourthCategoryId = fourth?.data.categoryId || '';
        obj.fourthCategoryId && arr.push(obj.fourthCategoryId);

        tableData.push(obj);
        valueModel.push(arr);
      });
      if (tableData.length > 100) {
        this.$message.warning('产品目录申请数量最多100条');
        tableData = tableData.slice(0, 100);
      }

      this.tableData = [...tableData];
      this.cloneTableData = _.cloneDeep(tableData);
      console.log(this.tableData, 'this.tableData');
    },
    // 迭代 2023-09-06 结束
    // 判断公司风险评级
    async checkCompanyRisk() {
      const { internalCode } = this.$store.state.USERINFO;
      const res = await api.checkCompanyRisk({ internalCode });
      if (res.code == '200') {
        if (res.data) {
          this.submitBtnType = 'primary';
        } else {
          // 没有服务管家提示：暂不允许申请产品目录
          // 有服务管家提示：暂不允许申请产品目录，请咨询服务管家
          this.submitBtnType = 'info';
          this.message = this.abbreviation ? '暂不允许申请产品目录，请咨询服务管家' : '暂不允许申请产品目录';
        }
      }
    },
    // 公司风险评分
    async checkCompanyRiskPoint() {
      const { internalCode } = this.$store.state.USERINFO;
      const res = await api.checkCompanyRiskPoint({ internalCode });
      if (res.code == '200') {
        this.riskScore = res.data || 0;
      }
    },
    companyTypeText() {
      let text = '';
      switch (this.formData.companyType) {
        case 'PRODUCER':
          // 生产商
          this.uploadFlag = true;
          text = '上传相关资质证明、特种设备许可证（如有）、生产装备清单及照片、检测设备清单及照片、车间照片';
          break;
        case 'AGENT':
          // 代理商
          this.uploadFlag = true;
          text = '上传代理证';
          break;
        case 'DISTRIBUTOR':
          // 流通商 隐藏上传附件按钮，无需上传附件
          this.uploadFlag = false;
          break;
      }
      return text;
    },
    // 上传成功
    handleImgSuccess(res, file) {
      console.log('handleImgSuccess', res);
      if (res.code == '200') {
        this.isLoad = false;
        this.$message.success('上传附件成功');
        this.fileList.push(file);
      } else {
        this.isLoad = false;
      }
    },
    // 上传之前校验
    handleBeforeUpload(file) {
      this.isLoad = true;
      console.log('handleBeforeUpload', file);
      const typeArr = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
      if (!typeArr.includes(file.type)) {
        this.$message.warning('上传附件失败，仅可上传.jpg .jpeg .png .pdf格式的文件');
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.warning('上传附件失败，附件大小不可超过10M');
        return false;
      }
    },

    // 点击附件
    async handlePreview(file) {
      const filePath = file.url ? file.url : file.response.data.downloadUrl;
      const res = await api.getSupplierLicence({ filePath });
      if (res.code == '200') {
        window.open(res.data, '_blank');
      }
    },
    //
    handleBeforeRemove(file) {
      this.isLoad = false;
      console.log('handleBeforeRemove', file);
      const format = this.commonHandleCheck(file.name);
      // 不正确的格式 直接 return 不调用弹窗
      if (file.size / 1024 / 1024 > 10 || file.status === 'ready') {
        return;
      }
      return this.$confirm('是否要删除此附件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
    },
    // 删除文件
    async handleImgRemove(file) {
      console.log('handleImgRemove');
      console.log(file, 'file');
      const filePath = file.url ? file.url : file.response.data.downloadUrl || '';
      const res = await api.removeCompanyIdentityLicense({ filePath });
      if (res.code == '200') {
        this.fileList.forEach((item, index) => {
          if (item.uid == file.uid) {
            this.fileList.splice(index, 1);
          }
        });
        this.$message.success('删除成功');
      }
    },

    // 查询公司身份及附件
    async queryCompanyIdentityAttach() {
      const params = { companyId: this.$store.state.USERINFO.companyId };
      const res = await api.queryCompanyIdentityAttach(params);
      if (res.code === '200') {
        // 返回有数据就展示附件数据，不可添加附件，没有数据生产商和代理商必须添加附件
        if (res.data.length) {
          const obj = {
            51: 'DISTRIBUTOR',
            52: 'PRODUCER',
            53: 'AGENT',
          };
          this.formData.companyType = obj[Number(res.data[0].data)];

          res.data.forEach((item) => {
            const obj = {};
            if (item.attachPath) {
              if (JSON.parse(item.attachPath).downloadUrl) {
                obj.name = JSON.parse(item.attachPath).fileName;
                obj.url = JSON.parse(item.attachPath).downloadUrl;
                this.fileList.push(obj);
              }
            }
          });
        }
      }
    },

    handleEvent(ev) {
      this.category = ev;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleFocus(row) {
      this.labelName = row.item.label;
      this.titleName = row.item.value;
    },
    handleInput(row) {
      if (row == '') {
        this.seekFlag = false;
        // this.tableData = this.tableData2;
        this.tableData = [...this.cloneTableData];
      }
    },
    // 去重
    deWeightThree(arr) {
      const map = new Map();
      for (const item of arr) {
        if (!map.has(item.value)) {
          map.set(item.value, item);
        }
      }
      return [...map.values()];
    },
    // 搜索提示框
    handleSuggestions(val) {
      const { queryString, cb } = val;
      this.firstCategoryNameList = [];
      this.secondCategoryNameList = [];
      this.thirdCategoryNameList = [];
      this.fourthCategoryNameList = [];

      for (const i of this.tableData) {
        for (const k in i) {
          if (k == 'firstCategoryName') {
            const obj = {
              value: i.firstCategoryName,
            };
            this.firstCategoryNameList.push(obj);
          } else if (k == 'secondCategoryName') {
            const obj = {
              value: i.secondCategoryName,
            };
            this.secondCategoryNameList.push(obj);
          } else if (k == 'thirdCategoryName') {
            const obj = {
              value: i.thirdCategoryName,
            };
            this.thirdCategoryNameList.push(obj);
          } else if (k == 'fourthCategoryName') {
            const obj = {
              value: i.fourthCategoryName,
            };
            this.fourthCategoryNameList.push(obj);
          }
        }
      }

      if (this.labelName == '一级类目名称') {
        const results1 = queryString
          ? this.firstCategoryNameList.filter(this.createFilter(queryString))
          : this.firstCategoryNameList;
        cb(this.deWeightThree(results1));
      } else if (this.labelName == '二级类目名称') {
        const results2 = queryString
          ? this.secondCategoryNameList.filter(this.createFilter(queryString))
          : this.secondCategoryNameList;
        cb(this.deWeightThree(results2));
      } else if (this.labelName == '三级类目名称') {
        const results3 = queryString
          ? this.thirdCategoryNameList.filter(this.createFilter(queryString))
          : this.thirdCategoryNameList;
        cb(this.deWeightThree(results3));
      } else if (this.labelName == '四级类目名称') {
        const results4 = queryString
          ? this.fourthCategoryNameList.filter(this.createFilter(queryString))
          : this.fourthCategoryNameList;
        cb(this.deWeightThree(results4));
      }
    },
    handleSelect(ev) {
      // 只有选择的才能搜索
      this.currentPage = 1;
      this.seekFlag = true;
      if (this.labelName == '一级类目名称') {
        const arr1 = [];
        this.cloneTableData.map((item) => {
          console.log(item.firstCategoryName);
          if (item.firstCategoryName == ev.value) {
            arr1.push(item);
          }
        });
        this.tableData = arr1;
      } else if (this.labelName == '二级类目名称') {
        const arr2 = [];
        this.cloneTableData.map((item) => {
          if (item.secondCategoryName == ev.value) {
            arr2.push(item);
          }
        });
        this.tableData = arr2;
      } else if (this.labelName == '三级类目名称') {
        const arr3 = [];
        this.cloneTableData.map((item) => {
          if (item.thirdCategoryName == ev.value) {
            arr3.push(item);
          }
        });
        this.tableData = arr3;
        console.log(this.tableData, '三级类目名称');
      } else if (this.labelName == '四级类目名称') {
        const arr4 = [];
        this.cloneTableData.map((item) => {
          if (item.fourthCategoryName == ev.value) {
            arr4.push(item);
          }
        });
        this.tableData = arr4;
      }
      console.log(this.tableData, '胜多负少的方第三方');
    },
    // 重置
    handleReset(row) {
      console.log(row);
      this.currentPage = 1;
      this.seekFlag = false;
      this.tableData = [...this.cloneTableData];
    },
    // 触发搜索按钮
    handleSearch(ev) {
      console.log(ev, '搜索');
      const { firstCategoryName, secondCategoryName, thirdCategoryName, fourthCategoryName } = ev;
      if (firstCategoryName == '' && secondCategoryName == '' && thirdCategoryName == '' && fourthCategoryName == '') {
        // this.tableData = this.tableData2;
        this.tableData = [...this.cloneTableData];
        return;
      }
      if (this.seekFlag) {
        return;
      }
      this.queryArr = [];
      this.currentPage = 1;
      this.cloneTableData.map((item) => {
        Object.keys(item).forEach((key) => {
          if (key == this.category.label && item[key] == this.category.value) {
            this.queryArr.push(item);
          }
        });
      });
      this.tableData = this.queryArr;
      this.queryData.pageNum = 1;
    },

    // 选择产品目录 按钮
    selectProductCatalog() {
      this.categoryVisible = true;
    },

    // 提交申请
    async clickSubmitApply() {
      let flag = false;
      // 必须选择企业类型
      if (this.formData.companyType == '') return this.$message.warning('请先选择企业类型');
      // 流通商不用上传附件，其他必须上传附件
      if (this.formData.companyType == 'DISTRIBUTOR') {
        flag = true;
      } else {
        flag = !!this.fileList.length;
      }
      // 提交申请
      if (flag) {
        this.loadingSub = true;
        debounce(() => {
          if (this.tableData.length == 0) {
            this.loadingSub = false;
            return this.$message.warning('尚未选择产品类目');
          }
          const attachPaths = [];
          this.fileList.forEach((item) => {
            const obj = {};
            if (item.response) {
              obj.downloadUrl = item.response.data.downloadUrl;
              obj.fileName = item.response.data.fileName;
            } else {
              obj.downloadUrl = item.url;
              obj.fileName = item.name;
            }
            attachPaths.push(obj);
          });
          const params = {
            // 流通商不上传附件
            attachPaths: this.formData.companyType == 'DISTRIBUTOR' ? null : attachPaths,
            companyIdentity: this.formData.companyType,
            categoryInfoList: this.tableData,
          };
          api.applyCategory(params).then((res) => {
            this.loadingSub = false;
            if (res.code === '200') {
              this.success_callback('提交成功，申请进度请进入“产品目录管理”中进行查看');
              this.fileList = [];
              this.tableData = [];
              this.$setStore('tableData_list', this.tableData);
              this.queryCompanyIdentityAttach();
            }
          });
        }, 500);
      } else {
        return this.$message.warning('请上传附件');
      }
    },

    /* clearFileList (uid) {
      let fileListIdx = this.fileList.findIndex(item => item.uid === uid)
      this.fileList.splice(fileListIdx, 1)
    }, */

    // 删除
    handleClickDel(row, idx) {
      console.log(row);
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.success_callback('删除成功。');
          if (this.seekFlag) {
            // ...this.cloneTableData;
            this.cloneTableData.map((item, index) => {
              if (
                item.categoryId == row.categoryId &&
                item.firstCategoryId == row.firstCategoryId &&
                item.secondCategoryId == row.secondCategoryId &&
                item.thirdCategoryId == row.thirdCategoryId &&
                item.fourthCategoryId == row.fourthCategoryId
              ) {
                this.cloneTableData.splice(index, 1);
              }
            });
          }
          const arr = [];
          const { firstCategoryId, secondCategoryId, thirdCategoryId, fourthCategoryId = '' } = row;
          arr.push(firstCategoryId, secondCategoryId, thirdCategoryId);
          fourthCategoryId && arr.push(fourthCategoryId);
          console.log(arr, 'arr');
          /* this.valueModel.forEach((item, index) => {
            if(item.toString() === arr.toString()) {
              this.valueModel.splice(1, index)
              break
            }
          }) */
          const valueModel = [...this.valueModel];
          for (let i = 0; i < valueModel.length; i++) {
            if (valueModel[i].toString() === arr.toString()) {
              this.propsKey++;
              this.valueModel.splice(i, 1);
              break;
            }
          }
          console.log(this.valueModel, 'this.valueModel');
          this.tableData.splice(idx, 1);
          this.cloneTableData.splice(idx, 1);
          this.$setStore('tableData_list', this.tableData);
          // this.dealTree(this.tableData, row.categoryId)
        })
        .catch((err) => {
          console.log(err);
          this.check_callback('已取消');
        });
    },

    // 得到所选类目的信息
    getCategoryInfo(val, level) {
      console.log(val, level);
      switch (val.categoryLevel) {
        case 1:
          this.levelList1.push(val);
          break;
        case 2:
          this.levelList2.push(val);
          break;
        case 3:
          this.levelList3.push(val);
          break;
        case 4:
          this.levelList4.push(val);
          break;
        default:
          break;
      }
      const arr = [
        this.levelList1[this.levelList1.length - 1],
        this.levelList2[this.levelList2.length - 1],
        this.levelList3[this.levelList3.length - 1],
        this.levelList4[this.levelList4.length - 1],
      ];
      this.tableArr = arr.filter(Boolean);
      this.tableArr.map((item, index) => {
        if (item && item.leafFlag) {
          this.tableArr.length = index + 1;
          this.categoryVisible = false;
        }
      });
    },

    // 服务管家
    async queryCompanyButler() {
      const res = await api.queryCompanyButler();
      if (res.code == '200' && res.data.length) {
        this.butlerInfo = res.data;
        const endMobile = this.butlerInfo[this.butlerInfo.length - 1].mobile;
        this.abbreviation = this.butlerInfo[0].abbreviation;
        this.butlerInfo.forEach((item) => (item.mobile = `${item.mobile}、`));
        this.butlerInfo[this.butlerInfo.length - 1].mobile = `${endMobile}。`;
      }
    },

    // 模糊查询
    searchLevel(val) {
      this.isActiveLevel = val;
    },

    // 成功提示
    success_callback(msg) {
      this.$message({
        message: msg,
        type: 'success',
      });
    },
    // 失败提示
    check_callback(msg) {
      this.$message({
        message: msg,
        type: 'warning',
      });
    },
    // 心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      const token = this.$cookies.get('epecToken');
      if (token) {
        const epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        const now = new Date().getTime();
        const time = epecTokenExpiredTime;
        const timeOutIn = null;
        let timeOut = null;
        if (time > now) {
          const interval = time - now;
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  padding: 15px 10px;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  background: #e8efff;
  .color {
    color: #f0250f;
    white-space: nowrap;
    font-weight: 700;
  }
  .box-content {
    flex: 1;
  }
  .link {
    color: #2587ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.exclusive-top {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  min-height: 44px;
  // line-height: 44px;
  background: #e8efff;
  box-sizing: border-box;
  padding: 15px 0 15px 20px;
  p {
    font-size: 16px;
    color: #333;
  }
  .color {
    color: #ef4c56;
    font-weight: bold;
  }
}
.company-info {
  width: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  .company-title {
    font-size: 16px;
    color: #333;
    line-height: 1;
    margin-bottom: 20px;
  }
  .company-select {
    width: 100%;
    display: flex;
  }
  .company-upload {
    width: 100%;
    height: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    position: relative;
    .upload-btn {
      display: flex;
    }
    .file-li {
      width: 18%;
      height: 50%;
      // float: right;
      // margin-right: 18px;
    }
    .msg {
      position: absolute;
      left: 100px;
      top: 5px;
      cursor: default;
    }
  }
}
::v-deep .el-upload-list__item {
  width: 18%;
  margin: 0 2% 10px 0;
  background: #f1f1f1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::v-deep .el-upload-list {
  margin-top: 10px;
  width: 70%;
  max-height: 100px;
  overflow: auto;
}
/* ::v-deep .el-upload-list {
  float: right;
  width: 70%;
  margin-right: 80px;
}

::v-deep .el-upload {
  float: left;
} */
::v-deep .el-icon-close-tip {
  display: none !important;
}
.companyType-text {
  margin-top: 10px;
  color: #666;
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
}

::v-deep .el-cascader {
  width: 600px;
}
.cascader-content {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.handle-bottom-btn {
  display: flex;
  justify-content: flex-end;
}
</style>
